import { useCallback, useMemo, useRef, useState } from 'react';
import {
  getControleDescargaRelatorioExcel,
  getControleDescargaRelatorioPdf
} from '@spark/services/descarga';
import { notification } from '@spark/ui-components/utils/notification';
import { normalizeDescargaFilters } from '../controleDescargaMapper';
import { resolveColunasExportacao } from '../resolveColunasExportacao';
import downloadBlob from '../utils/downloadBlob';

export const useControleDescargaExport = ({
  filtros,
  exportConfig,
  disabled,
  excelFileName,
  pdfFileName
}) => {
  const [loadingExport, setLoadingExport] = useState(null);
  const columnLayoutRef = useRef(null);

  const exportFilters = useMemo(
    () => normalizeDescargaFilters(filtros),
    [filtros]
  );

  const resolveExportColunas = useCallback(() => resolveColunasExportacao({
    columnConfigKey: exportConfig.columnConfigKey,
    padraoVisiveis: exportConfig.padraoVisiveis,
    naoExportaveis: exportConfig.naoExportaveis,
    todasIds: exportConfig.todasIds,
    layout: columnLayoutRef.current
  }), [exportConfig]);

  const handleColumnLayoutChange = useCallback((layout) => {
    columnLayoutRef.current = layout;
  }, []);

  const handleExportExcel = useCallback(async () => {
    try {
      setLoadingExport('excel');
      const colunasRelatorio = resolveExportColunas();
      const blob = await getControleDescargaRelatorioExcel({
        ...exportFilters,
        ColunasRelatorio: colunasRelatorio
      });
      downloadBlob(blob, excelFileName, 'xlsx');
      notification.success('Relatorio Excel gerado com sucesso!');
    } catch (error) {
      console.error('Erro ao gerar relatorio Excel de descarga:', error);
      notification.error('Nao foi possivel gerar o relatorio Excel.');
    } finally {
      setLoadingExport(null);
    }
  }, [excelFileName, exportFilters, resolveExportColunas]);

  const handleExportPdf = useCallback(async () => {
    try {
      setLoadingExport('pdf');
      const colunasRelatorio = resolveExportColunas();
      const blob = await getControleDescargaRelatorioPdf({
        ...exportFilters,
        ColunasRelatorio: colunasRelatorio
      });
      downloadBlob(blob, pdfFileName, 'pdf');
      notification.success('Relatorio PDF gerado com sucesso!');
    } catch (error) {
      console.error('Erro ao gerar relatorio PDF de descarga:', error);
      notification.error('Nao foi possivel gerar o relatorio PDF.');
    } finally {
      setLoadingExport(null);
    }
  }, [exportFilters, pdfFileName, resolveExportColunas]);

  const exportDisabled = disabled || !!loadingExport;

  return {
    loadingExport,
    exportDisabled,
    handleExportExcel,
    handleExportPdf,
    handleColumnLayoutChange
  };
};
